export default "__VITE_ASSET__OKtkXSvW__"